import React from 'react'
import classNames from 'classnames'
import { Popconfirm as AntPopconfirm } from 'antd'
import './Popconfirm.scss'
const Popconfirm = ({ className, ...restProps }) => {
  const props = {
    ...restProps,
    className: classNames(className, 'pan-popconfirm')
  }

  return (
    <AntPopconfirm {...props} />
  )
}
Popconfirm.AntPopconfirm = AntPopconfirm
export default Popconfirm
